<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo19bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 68px; top: 141px">
      <p>Lee los globos.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 68px; top: 190px">
      <p>
        Dibuja los animales y escribe<br />
        quién lo dijo.
      </p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 68px; top: 270px">
      <p>Sube fotos de tus dibujos.</p>
    </span>

    <p id="tag01" class="textBase basicItem01 tagDefault">EL PATO</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">EL CARACOL</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">EL CANGREJO</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">EL SAPO</p>

    <img
      id="globe01"
      class="text-box-a pageElement hover-animation-a"
      src="/pages/img/sordoglo/svgGlo19Globe01.svg"
    />
    <img
      id="globe02"
      class="text-box-a pageElement hover-animation-a"
      src="/pages/img/sordoglo/svgGlo19Globe02.svg"
    />
    <uploaded-image
      class="image01 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>

    <div
      id="button01"
      style="position: absolute; margin-left: 2.5%; margin-top: 65%; z-index: 5"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
        class="pageElement"
      ></image-upload>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      defaultText="EL PATO"
      number="100"
      id="inputField01Disabled"
      disabled
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />

    <img
      id="duck"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo7DuckFlip.svg"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 67.29px;
  top: 40px;
}
#tag01 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 467px;
  top: 110px;
}
#tag02 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 737px;
  top: 110px;
}
#tag03 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 467px;
  top: 200px;
}
#tag04 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 737px;
  top: 200px;
}
#globe01 {
  position: absolute;
  left: 86px;
  top: 348px;
  z-index: 5;
}
#globe02 {
  position: absolute;
  left: 544px;
  top: 352px;
  z-index: 5;
}
.image01 {
  position: absolute;
  width: 482px;
  height: 309px;
  left: 521px;
  top: 399px;
}
#button01 {
  width: 216px;
  height: 77px;
  left: 777px;
  top: 5px;
}
#inputField01Disabled {
  position: absolute;
  width: 228px;
  height: 31px;
  left: 92px;
  top: 674px;
  z-index: 5;
}
#inputField01 {
  position: absolute;
  width: 228px;
  height: 31px;
  left: 533px;
  top: 674px;
  z-index: 5;
}
#duck {
  position: absolute;
  left: 154px;
  top: 467px;
  z-index: 5;
}
</style>

<script>
import ImageUpload from "../../../components/ImageUpload.vue";
export default {
  name: "App",
  components: {
    ImageUpload,
  },
};
</script>